<template>
	<AppDialog dialogName="SemiConfirmationDialog" min-width="500" :height="height">
		<div class="semi-confirmation-dialog flex-centerize flex-column" :style="`height: ${height}px; max-width: ${contentMaxWidth}px;`">
			<h1 class="text-center mb-2" :class="{ 'white-space-pre-wrap': preWrapTitle }">{{ title }}</h1>
			<h3 v-if="description" class="reg text-center mx-4">{{ description }}</h3>
			<div class="soft-note text-align-center soft-message font-size-sm" v-if="softNote">{{ softNote }}</div>
			<div class="mt-12 display-flex flex-column">
				<PrimaryButton class="yes-text" @click="yes">
					{{ yesText }}
				</PrimaryButton>
				<h2 class="no-text cursor-pointer flex-centerize text-underline pt-4" @click="no">{{ noText }}</h2>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default {
	name: 'SemiConfirmationDialog',
	components: { AppDialog },
	props: {
		dialogPromiseHandlers: { type: Object },
		title: { type: String },
		preWrapTitle: { type: Boolean, default: false },
		description: { type: String },
		softNote: { type: String },
		yesText: { type: String },
		noText: { type: String },
		height: { type: [String, Number], default: '280' },
		contentMaxWidth: { type: Number, default: undefined },
	},
	methods: {
		yes() {
			this.dialogPromiseHandlers.resolve(true);
			this.close();
		},
		no() {
			this.dialogPromiseHandlers.resolve(false);
			this.close();
		},
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
	},
	computed: {},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
.semi-confirmation-dialog {
	margin: 0 auto;

	.yes-text {
		border-radius: var(--Border-Radius-borderRadiusLG, 8px);
	}
	.no-text {
		color: #6060f7;
	}
	.white-space-pre-wrap {
		white-space: pre-wrap;
	}
	.soft-note {
		margin: 8px 0 -24px 0;
	}
}
</style>
